import { createSlice } from "@reduxjs/toolkit";
import { generateCustomMedia, uploadImage } from "./thunk";


const initialState = {
  imageData: [],
  generateImageLoading: false,
  error: null,
};

const customMediaSlice = createSlice({
  name: "customMedia",
  initialState,
  reducers: {
    resetImageData: (state) => {
      state.generateImageLoading = false;
      state.imageData = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // ------------------------------------------------------Upload Image
      .addCase(uploadImage.pending, (state) => {
        state.generateImageLoading = true;
        state.error = null;
      })
      .addCase(uploadImage.fulfilled, (state, action) => {
        state.generateImageLoading = false;
        state.generatedImage = action.payload;
      })
      .addCase(uploadImage.rejected, (state, action) => {
        state.generateImageLoading = false;
        state.error = action.payload;
      })
      // ------------------------------------------------------Generate Image/Video
      .addCase(generateCustomMedia.pending, (state) => {
        state.generateImageLoading = true;
        state.error = null;
      })
      .addCase(generateCustomMedia.fulfilled, (state, action) => {
        state.generateImageLoading = false;
        state.generatedImage = action.payload;
      })
      .addCase(generateCustomMedia.rejected, (state, action) => {
        state.generateImageLoading = false;
        state.error = action.payload;
      })
  },
});

export const { clearError } = customMediaSlice.actions;
export default customMediaSlice.reducer;